import { MouseEvent, useCallback, useState } from 'react';

export const useCollapsibleText = () => {
	const [showCollapse, setShowCollapse] = useState(false);
	const [collapsed, setCollapsed] = useState(true);

	const ref = useCallback((node: HTMLParagraphElement) => {
		if (node === null) return;
		if (node.scrollHeight > node.clientHeight) {
			setShowCollapse(true);
		}
	}, []);

	const toggle = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		setCollapsed(!collapsed);
	};

	return {
		ref,
		show: showCollapse,
		collapsed,
		toggle,
	};
};
